import React from 'react';
import { useNavigate } from 'react-router-dom';
import formatDateTime from './hjelpere/formatDateTime.js';

const ServiceCustomerInfo = ({ serviceDetails, customer }) => {
    const navigate = useNavigate();

    // Funksjon for å hente registreringsdato fra MongoDB ObjectId
    const getCreatedAtFromObjectId = (objectId) => {
        if (!objectId) return null;
        const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000; // Konverter til millisekunder
        return new Date(timestamp);
    };

    // Hent og formater registreringsdato fra _id
    const registrertDatoObj = getCreatedAtFromObjectId(serviceDetails._id);
    const registrertDato = registrertDatoObj ? formatDateTime(registrertDatoObj) : 'Ukjent dato';

    console.log(`Service ID: ${serviceDetails._id}`);
    console.log(`- Registrert dato (ISO): ${registrertDatoObj}`);
    console.log(`- Formatert registrert dato: ${registrertDato}`);

    return (
        <div
            onClick={() => navigate(`/customer-details/${customer._id}`)} // Naviger til kundedetaljsiden
            className='p-4 border border-gray-300 rounded-lg mb-6 cursor-pointer hover:bg-gray-100 transition-colors duration-200'
        >
            <div>
                <p>
                    <strong>Dato registrert:</strong> {registrertDato}
                    {serviceDetails.endretdato && (
                        <span> ({formatDateTime(serviceDetails.endretdato)})</span>
                    )}
                </p>
            </div>
            <div>
                <p>
                    <strong>Kunde:</strong> {customer.firstName} {customer.lastName},{' '}
                    {customer.phoneNumber}
                    {customer.email && <span>, {customer.email}</span>}
                </p>
            </div>
        </div>
    );
};

export default ServiceCustomerInfo;
